/**
 * @file client.ts
 * @description Pre-configured AddSearch API client.
 * Uses the generic createApiClient with AddSearch base URL.
 * Reference: https://www.addsearch.com/docs/api-reference/search-api/
 */

import { createApiClient } from '@/lib/api/client';

const ADDSEARCH_BASE_URL = 'https://api.addsearch.com/v1';

/**
 * AddSearch REST API client.
 * Timeout and retry settings are tuned for interactive search UX.
 */
export const addSearchClient = createApiClient({
  baseUrl: ADDSEARCH_BASE_URL,
  timeoutMs: 5000,
  retries: 1,
  retryDelayMs: 300,
});
